import { render } from "./PeoplePage.vue?vue&type=template&id=672ba48a&scoped=true"
import script from "./PeoplePage.vue?vue&type=script&lang=js"
export * from "./PeoplePage.vue?vue&type=script&lang=js"

import "./PeoplePage.vue?vue&type=style&index=0&id=672ba48a&scoped=true&lang=css"

import exportComponent from "/opt/stagecoach/apps/pa-wildflower-selector/deployments/2022-05-18-09-54-08/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672ba48a"]])

export default __exports__